import {Component, OnInit} from '@angular/core';
import { ServicesService } from '../services.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';

import * as $ from 'jquery';

@Component({
  selector: 'app-photo-selection',
  templateUrl: './photo-selection.component.html',
  styleUrls: ['./photo-selection.component.css']
})
export class PhotoSelectionComponent implements OnInit {

    apiBaseUrl: string = environment.apiBaseUrl;
    header = 'l-header';
    navbar = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    productid;
    jobid;
    photoid;
    clientName;
    shootName;
    clientType;
    clientId;

    individual_photos_availability = 0;
    group_photos_availability = 0;

    group_photos_quantity= [];
    individual_photos_quantity = [];

    no_product_flag = 0;

    // -----
    individualAndGruopPhotoes = [];

    modelImagesArray        = [];
    modelImagesArrayChunks  = [];

    groupOrIndividualButtonClicked;

    setIndividualOrGroupIndex;

    hrefModel = '';

    addtocartdisabled = false;
    // -----Private
    uniqueCode;
    privateImagePopUp = 'assets/img/dummy.jpg';

    imageFound = false;
    pName = '';
    sName = '';
    cName = '';
    erMsg= '';

  constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) { }

  ngOnInit() {
      this.route.queryParams.subscribe(params => {
          // console.log(params['jobid'], params['job_id']);
          this.productid = params['product_id'];
          this.jobid = params['jobid'] == undefined ? params['job_id'] : params['jobid'];
         // console.log('This is productid ' + this.productid);
      });
      this.getProduct();
      this.getPhotos();
      this.getJObName();
      // $('#Public').modal('show');
  }


     public getJObName() {
        this._service.getJObName(this.jobid).subscribe((data: any) => {
           // console.log('getJObName', data);
           this.shootName = data.result[0]['shoot_name'];
           this.clientId = data.result[0]['client_id'];
            this.getClientDet();
        });
    }
    public getClientDet(){
        this._service.getClientName(this.clientId).subscribe((clientObj: any) => {
            // console.log('ClientObj', clientObj);
            this.clientType = clientObj.result[0].client_type;
            $('.tb-preloader-wave').fadeOut();
            $('#tb-preloader').delay(200).fadeOut('slow').remove();
        });
    }
    public chunks(array, size) {
        let results = [];
        results = [];
        while (array.length) {
            results.push(array.splice(0, size));
        }
        return results;
    }

    public moveBack() {
         swal({
            title: 'Oops!',
            html: "Going back to the products will not add this product to your cart if you have not selected your photos.<br> To add the product to your cart once your photo selections are made please click on the Add to Cart button below. <i class='fa fa-frown-o'></i>",
            type: 'warning',
            confirmButtonText: 'Ok',
            showCancelButton: true,
            focusCancel: true,
             cancelButtonColor: '#d33',
        }).then((willDelete) => {
             if (willDelete.value) {
                 this.router.navigate(['product'], { queryParams: {'jobid': this.jobid}});
             }
         });
        // console.log('moveBack');
    }
    getPhotos() {
        this._service.getPhotos(this.jobid).subscribe((data: any) => {
            // console.log(data.result['0']);
            this.individualAndGruopPhotoes = data.result;
           // console.log('individualAndGruopPhotoes ',this.individualAndGruopPhotoes);
        });
    }
    // This function will decide model + previous seleted image + set image in the model
    getModelFlag(index, groupOrIndividual) {
        this.erMsg = '';
        this.pName=''; this.sName='';this.cName='';
        this.setIndividualOrGroupIndex = index;
       // console.log('setIndividualOrGroupIndex', this.setIndividualOrGroupIndex);

        // Private mode reset code
        this.privateImagePopUp = 'assets/img/dummy.jpg';
        this.uniqueCode = '';

        this.modelImagesArray = [];
        this.modelImagesArrayChunks = [];
        if (this.individualAndGruopPhotoes.hasOwnProperty(groupOrIndividual)) { // this means it is public
            // console.log('yash',this.individualAndGruopPhotoes[groupOrIndividual]);
            for (const key in this.individualAndGruopPhotoes[groupOrIndividual]) {
                // console.log('yash',key);
                // console.log('yash',this.individualAndGruopPhotoes[groupOrIndividual][key].photo);
                const photo = this.individualAndGruopPhotoes[groupOrIndividual][key].photo;
                const id = this.individualAndGruopPhotoes[groupOrIndividual][key].id;
                const file_name = this.individualAndGruopPhotoes[groupOrIndividual][key].file_name;
                let selectedImage = false;
                if (groupOrIndividual) { // if this is 1 that means it is individual button is clicked and if 0 means group
                    this.groupOrIndividualButtonClicked = 'individual_photos_quantity';
                }else {
                    this.groupOrIndividualButtonClicked = 'group_photos_quantity';
                }

                // This code is for matching previous seleted image start
                if (this[this.groupOrIndividualButtonClicked][index]) {
                    const a = parseInt(id);
                    const b = parseInt(this[this.groupOrIndividualButtonClicked][index].id);
                    if (a == b) {
                        selectedImage = true;
                    }
                }
                // This code is for matching previous seleted image end
                this.modelImagesArray.push({'photo': photo, 'id': id, 'selectedImage': selectedImage,'file_name':file_name});
            }
            this.modelImagesArrayChunks = this.chunks(this.modelImagesArray,3);
           // console.log('this.modelImagesArrayChunks', this.modelImagesArrayChunks);

            // console.log('this.modelImagesArray',this.modelImagesArray);
            //    console.log('groupOrIndividual',groupOrIndividual);
            this.hrefModel =  'Public';
        }else {
            this.hrefModel =  'Private';
            if (groupOrIndividual) { // if this is 1 that means it is individual button is clicked and if 0 means group
                this.groupOrIndividualButtonClicked = 'individual_photos_quantity';
            }else {
                this.groupOrIndividualButtonClicked = 'group_photos_quantity';
            }
           // console.log('this.groupOrIndividualButtonClicked', this.groupOrIndividualButtonClicked);
        }
    }

    getProduct() {
        this._service.getProduct(this.productid).subscribe((data: any) => {
            // console.log('product_data', data);
            if (data.result.length > 0)
            {
                this.no_product_flag = 1;
                this.individual_photos_availability = data.result[0].individual_photos_availability;
                this.clientName                     = data.result[0].name;
                this.group_photos_availability      = data.result[0].group_photos_availability;
                this.group_photos_quantity          = Array(data.result[0].group_photos_quantity);
                this.individual_photos_quantity     = Array(data.result[0].individual_photos_quantity);
                // console.log('individual_photos_quantity', this.individual_photos_quantity);
            }else {
                this.no_product_flag = 0;
            }

            $('.tb-preloader-wave').fadeOut();
            $('#tb-preloader').delay(200).fadeOut('slow').remove();

        }, (err: HttpErrorResponse) => {
            this.no_product_flag = 0;
        });

    }
    imageClick(imgSrc, itemId,fileName) {
      this[this.groupOrIndividualButtonClicked][this.setIndividualOrGroupIndex] = {id: itemId, src: imgSrc ,fileName:fileName};
     // console.log(this.groupOrIndividualButtonClicked, this[this.groupOrIndividualButtonClicked]);
    }

    getImage(i, arrayType) { // arrayType = individual_photos_quantity || group_photos_quantity
        if (!this[arrayType][i]) {
            return 'assets/img/dummy.jpg';
        }
        return this.apiBaseUrl + '/' + this[arrayType][i].src;
    }

    getFileName(i, arrayType) { // arrayType = individual_photos_quantity || group_photos_quantity
        if (!this[arrayType][i]) {
            return '';
        }
        return this[arrayType][i].fileName;
    }

    getPrivateImage() {
      const file_name = this.uniqueCode;
      const job_id = this.jobid;
      const data = {'file_name': file_name, 'job_id': job_id};
      //  console.log('getPrivateImage data', data);

      this._service.getPrivateImage(data).subscribe((res: any) => {
         // console.log('getPrivateImage service res', res);
          if (res.status == 200) {
              this.imageClick(res.result.photo, res.result.id, file_name);
              this.privateImagePopUp = this.apiBaseUrl + '/' + res.result.photo;
          }else {
              this.imageFound = true;
              setTimeout(() => {
                  this.imageFound = false;
              }, 2000);
          }

      });

    }

    showImage(src) {

        const imgUrl =  src;
        // console.log(imgUrl);
        swal({
            html:  "<img src='" + imgUrl + "' style='width:100%;'>",
            showConfirmButton: false,
            showCancelButton:true,
            cancelButtonText: "Close",
            cancelButtonColor: '#d33',
            //width:'600px',
            //height:'600px',
            customClass: 'swal-wide',
        });
    }

    verifyFormData() {
        // console.log('groupOrIndividualButtonClicked= ',this.groupOrIndividualButtonClicked);
        // console.log('setIndividualOrGroupIndex= ',this.setIndividualOrGroupIndex);
        if(this.pName=='' || this.sName=='' || this.cName==''){
            this.erMsg='Please fill all the above fields';
        }else if(this[this.groupOrIndividualButtonClicked][this.setIndividualOrGroupIndex]==undefined){
            this.erMsg='Please Select an image';
        }else{
            this[this.groupOrIndividualButtonClicked][this.setIndividualOrGroupIndex].imageDetail = { 'cname':this.cName,pname:this.pName, sname: this.sName};
            // $('#myModal').modal('hide');
            $('.close-modal').trigger('click');
            this.pName=''; this.sName='';this.cName='';
        }
        // this[this.groupOrIndividualButtonClicked].imageDetail = { 'cname':this.pName,pname:this.cName, sname: this.sName};
        // console.log(this[this.groupOrIndividualButtonClicked]);
    }

    addToCart() {
      // const length = this.individual_photos_quantity;
      // console.log('addToCart', this.individual_photos_quantity[0]);
        let allPhotoesSelectedFlag = true;
        if (this.individual_photos_quantity) {
            for (const individual of this.individual_photos_quantity) {
                if (individual == undefined) {
                    allPhotoesSelectedFlag = false;
                }
            }
        }

        if (this.group_photos_quantity) {
            for (const group of this.group_photos_quantity) {
                if (group == undefined) {
                    allPhotoesSelectedFlag = false;
                }
            }
        }

        if (!allPhotoesSelectedFlag) {
            swal({
                title: 'Oops!',
                text: 'Please select all required photos for this product',
                type: 'warning',
                confirmButtonText: 'Ok',
            });
        }else {
            this.addtocartdisabled = true;
            const userData =  localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};

            const user_id     = userData.hasOwnProperty('id') ?  userData.id : '';

            if (user_id == '') {
                swal({
                    title: 'Oops!',
                    text: 'In order to add products to your cart and complete an order, you have to be logged in to a verified account. Please login or Register your account to continue.',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            const product_id  = this.productid;
            const job_id      = this.jobid;
            let item_id;
            let item_id_arr   = [];
            let item_det_arr   = {};
            let item_det_pocket   = [];
          // console.log('individual_photos_quantity',this.individual_photos_quantity);
            if (this.individual_photos_quantity) {
                // let i=0;
                for (const individual of this.individual_photos_quantity) {
                    // console.log('loop',individual);                    
                    item_id = individual.id;
                    item_id_arr.push(item_id);
                    // item_det_pocket.push([item_id,individual.imageDetail]);
                    if(this.clientType=='school')
                    item_det_arr[item_id] = {'detail':individual.imageDetail};                    
                    // const data = {'user_id': user_id, 'product_id': product_id, 'job_id': job_id, 'item_id': item_id};                    
                    // this._service.addproduct(data).subscribe((data1: any) => {
                    //
                    // });
                }
            }
            // console.log('group_photos_quantity',this.group_photos_quantity);
            // item_det_arr = [];
            if (this.group_photos_quantity) {
                for (const group of this.group_photos_quantity) {
                    // console.log('loop',group.id);
                    item_id = group.id;
                    item_id_arr.push(item_id);                    
                    if(this.clientType=='school')
                    item_det_arr[item_id] = {'detail':group.imageDetail};                    
                    // const data = {'user_id': user_id, 'product_id': product_id, 'job_id': job_id, 'item_id': item_id};
                    // console.log(data);
                    // this._service.addproduct(data).subscribe((data1: any) => {
                    //
                    // });
                }
            }

            const data = {'user_id': user_id, 'product_id': product_id, 'job_id': job_id, 'item_id': item_id_arr,'item_det':item_det_arr};
           // console.log('add to cart data', data);
            this._service.addproduct(data).subscribe((data1: any) => {
                // console.log('add to cart response', data1);
                const that = this;
                if (data1) {
                    swal({
                        title: 'Congratulations!',
                        text: 'The product has been added to your cart.',
                        type: 'success',
                        confirmButtonText: 'Ok',
                    }).then(function(isConfirm) {
                        that.router.navigate(['/product'],{ queryParams: { jobid: that.jobid } } );
                    });
                }else {
                    swal({
                        title: 'Opps!',
                        text: 'Something went wrong',
                        type: 'error',
                        confirmButtonText: 'Ok',
                    });
                }

            });



        }

    }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/photo-selection/photo-selection.component.ts